const qDictionary = ["quote",
"quick",
"quite",
"equal",
"queen",
"query",
"quiet",
"quest"]; export default qDictionary;